module.exports = __webpack_public_path__ + "img/valance-vintage-scallop.4f4d25f6.svg";